import { Tabs } from '@mantine/core';
import { ProfileUser } from '../ProfileUser';
import { TransactionCard } from './TransactionCard';
import { TransactionCoins } from './TransactionCoins';
export const Transaction: React.FC = () => {
  return <Tabs.Panel value="transaction">
      <ProfileUser />
      <TransactionCoins />
      <TransactionCard />
    </Tabs.Panel>;
};